import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { api } from "../../../lib/api";
import Field from "../components/Field";

/**
 * Blocks tab — ad-hoc closures (vacation, sick day, family event).
 *
 * Distinct from the Holidays panel (recurring annual closures) and from the
 * Hours Overrides panel (date-range schedule overrides on specific weekdays).
 *
 * Extracted from BusinessDashboardShell.jsx (iter28 refactor step 2.4).
 * No logic, UX or API change — only the file location.
 *
 * Capability: gated by `blocks:manage` at the shell level.
 */
export default function Blocks({ businessId }) {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ start_at: "", end_at: "", reason: "" });

  async function load() {
    const { data } = await api.get(`/businesses/${businessId}/blocks`);
    setItems(data);
  }
  useEffect(() => { load(); }, [businessId]);

  async function submit(e) {
    e.preventDefault();
    const payload = {
      start_at: new Date(form.start_at).toISOString(),
      end_at: new Date(form.end_at).toISOString(),
      reason: form.reason,
    };
    await api.post(`/businesses/${businessId}/blocks`, payload);
    setForm({ start_at: "", end_at: "", reason: "" });
    load();
  }

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <form onSubmit={submit} className="card-soft p-5 space-y-3" data-testid="block-form">
        <h3 className="font-display text-xl font-medium">Blocco orario / Ferie</h3>
        <Field label="Inizio"><input type="datetime-local" required className="input-soft" value={form.start_at} onChange={(e) => setForm({ ...form, start_at: e.target.value })} data-testid="block-start" /></Field>
        <Field label="Fine"><input type="datetime-local" required className="input-soft" value={form.end_at} onChange={(e) => setForm({ ...form, end_at: e.target.value })} data-testid="block-end" /></Field>
        <Field label="Motivo"><input className="input-soft" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="block-reason" /></Field>
        <button className="btn-accent w-full" data-testid="block-submit"><Plus className="h-4 w-4 mr-2" />Aggiungi blocco</button>
      </form>
      <div>
        <h3 className="font-display text-xl font-medium mb-3">Blocchi attivi</h3>
        <div className="space-y-3">
          {items.map((b) => (
            <div key={b.id} className="card-soft p-4 text-sm" data-testid={`block-${b.id}`}>
              <div className="font-medium">{b.reason || "Blocco"}</div>
              <div className="text-xs text-zinc-500 dark:text-zinc-400">
                {new Date(b.start_at).toLocaleString("it-IT")} → {new Date(b.end_at).toLocaleString("it-IT")}
              </div>
            </div>
          ))}
          {items.length === 0 && <div className="text-sm text-zinc-500 dark:text-zinc-400">Nessun blocco attivo.</div>}
        </div>
      </div>
    </div>
  );
}
